import {useCallback} from 'react';

import {useChangeLocationDialogStore} from './store/useChangeLocationDialogStore';
import {useChangeSpecialtyDialogStore} from './store/useChangeSpecialtyDialogStore';
import {useChangeUnitDialogStore} from './store/useChangeUnitDialogStore';
import {useSummaryChangeDrawerStore} from './store/useSummaryChangeDrawerStore';
import {useSummaryAbandonFlowStore} from './store/useSummaryAbandonFlowStore';
import {ChangeFlowVariantEnum} from '../../ui/components/ChangeFlowDialog/constants';

export function useBookingSummary() {
	const changeLocationState = useChangeLocationDialogStore(state => state.changeLocationDialog);
	const setChangeLocationState = useChangeLocationDialogStore(
		state => state.setChangeLocationDialog,
	);
	const changeSpecialtyState = useChangeSpecialtyDialogStore(
		state => state.changeSpecialtyDialog,
	);
	const setChangeSpecialtyState = useChangeSpecialtyDialogStore(
		state => state.setChangeSpecialtyDialog,
	);
	const changeUnitState = useChangeUnitDialogStore(state => state.changeUnitDialog);
	const setChangeUnitState = useChangeUnitDialogStore(state => state.setChangeUnitDialog);
	const openDrawerState = useSummaryChangeDrawerStore(state => state.summaryChangeDrawer);
	const setOpenDrawerState = useSummaryChangeDrawerStore(state => state.setSummaryChangeDrawer);
	const abandonFlowState = useSummaryAbandonFlowStore(state => state.summaryAbandonFlow);
	const setAbandonFlowState = useSummaryAbandonFlowStore(state => state.setSummaryAbandonFlow);

	const handleChangeModals = useCallback((type: ChangeFlowVariantEnum | 'contact' | 'email') => {
		setOpenDrawerState(false);
		if (type === ChangeFlowVariantEnum.LOCATION) {
			setChangeLocationState(true);
			return;
		}
		if (type === ChangeFlowVariantEnum.SPECIALTY) {
			setChangeSpecialtyState(true);
			return;
		}
		if (type === ChangeFlowVariantEnum.UNIT) {
			setChangeUnitState(true);
		}
	}, []);

	return {
		changeLocationState,
		changeSpecialtyState,
		changeUnitState,
		openDrawerState,
		setChangeLocationState,
		setChangeSpecialtyState,
		setChangeUnitState,
		setOpenDrawerState,
		handleChangeModals,
		abandonFlowState,
		setAbandonFlowState,
	};
}
